module.exports = __webpack_public_path__ + "img/UnnamedCharacter1.018bc1bd.png";